export default class WorkspaceModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }

  defaults() {
    return {
      host: '',
      employee_host: '',
      workspace_id: '',
      sso_methods: [],
      company_name: '',
      theme: null
    };
  }
}
